import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const FounderStory = () => {
  return (
    <section className="py-12 md:py-16 lg:py-20 bg-card">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4">
            Meet Our Founder
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            The vision and passion behind Chapati Plus
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden shadow-xl aspect-[3/4]">
              <Image
                src="/assets/images/ceo-1781081599699.jpg"
                alt="Portrait of James Makuei, founder of Chapati Plus, wearing traditional South Sudanese attire with modern business jacket, standing confidently in restaurant with warm smile and welcoming gesture"
                className="w-full h-full object-cover" />
            </div>
            
            <div className="absolute -bottom-4 -left-4 bg-primary text-primary-foreground p-4 md:p-6 rounded-xl shadow-xl max-w-xs">
              <p className="font-accent text-lg md:text-xl mb-1">"Food brings us together"</p>
              <p className="text-xs md:text-sm opacity-90">- Garang MARENG</p>
            </div>
          </div>
          
          <div className="space-y-4 md:space-y-6 order-1 lg:order-2">
            <div className="space-y-3 md:space-y-4">
              <h3 className="text-xl md:text-2xl font-bold text-foreground">Garang MARENG</h3>
              <p className="text-sm md:text-base text-primary font-semibold">Founder</p>
            </div>
            
            <div className="space-y-3 md:space-y-4 text-sm md:text-base text-muted-foreground leading-relaxed">
              <p>
                When I started Chapati Plus. It was all about the site's hustle business but in the process I fell in love with the brand and I knew this definitely more than what I thought. It's a people's business, it's a dynamic business and that really drives me.
              </p>
            </div>
            
            <div className="flex flex-wrap gap-3 pt-4">
              <div className="flex items-center gap-2 bg-muted px-4 py-2 rounded-lg">
                <Icon name="GraduationCap" size={20} color="var(--color-primary)" />
                <span className="text-sm font-medium">Logistics & Procurement Graduate</span>
              </div>
              <div className="flex items-center gap-2 bg-muted px-4 py-2 rounded-lg">
                <Icon name="Award" size={20} color="var(--color-secondary)" />
                <span className="text-sm font-medium">12+ Years Experience</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderStory;